import { useCallback } from 'react';

import { useTheme as useFenrirV1Theme } from '@rtkwlf/fenrir-react';

import { useThemeMode as useFenrirV2Theme } from '@packages/fenrir/fenrir-provider';

export const useTheme = () => {
  const theme = useFenrirV1Theme();
  const { mode, toggleMode } = useFenrirV2Theme();

  const setMode = useCallback(
    (value: 'light' | 'dark') => {
      theme?.setThemeMode(value);
      toggleMode(value);
    },
    [theme, toggleMode],
  );

  return [mode, setMode] as const;
};
